import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { DefaultAnnualFee } from '@classes/default-annual-fee';
import { DefaultPriceService } from 'app/core/services/default-price.service';
import { IndexService } from 'app/core/services/index.service';
import { UiService } from 'app/core/services/ui.service';

@Component({
  selector: 'app-price-annual-fee',
  templateUrl: './price-annual-fee.component.html',
  styleUrls: ['./price-annual-fee.component.scss']
})
export class PriceAnnualFeeComponent implements OnInit {

  displayIndexesPrice = false;
  dataSource = new MatTableDataSource<DefaultAnnualFee>();
  selectedRowID: string;
  displayedColumns: string[] = [
    'name',
    'priceZoneA',
    'priceZoneB'
  ];
  constructor(
    private uiService: UiService,
    private defaultPriceService: DefaultPriceService,
    private indexService: IndexService
  ) { }

  ngOnInit() {
    this.getDefaultAnnualFee();
  }

  selectItemClick(item: DefaultAnnualFee) {
    this.selectedRowID = item.id || '';
  }
  getDefaultAnnualFee() {
    this.uiService.addRouteLoading();
    this.defaultPriceService.getDefaultAnnualFee().subscribe(data => {
      data.forEach(fe => {
        fe.indexPriceZoneA = (fe.priceZoneA || 1) * (this.indexService.currentCoef?.value || 1)
        fe.indexPriceZoneB = (fe.priceZoneB || 1) * (this.indexService.currentCoef?.value || 1)
      })
      this.dataSource.data = data;
      this.uiService.removeRouteLoading();
    }, error => {
      console.error(error);
      this.uiService.removeRouteLoading();
    })
  }

}
